import { render, staticRenderFns } from "./ActivityInfo.vue?vue&type=template&id=ada15826&scoped=true&"
import script from "./ActivityInfo.vue?vue&type=script&lang=js&"
export * from "./ActivityInfo.vue?vue&type=script&lang=js&"
import style0 from "./ActivityInfo.vue?vue&type=style&index=0&id=ada15826&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada15826",
  null
  
)

export default component.exports